export default {
    mounted() {
        this.updateCanonical();
    },
    watch: {
        "$route.fullPath"() {
            this.updateCanonical();
        },
    },
    methods: {
        updateCanonical() {
            let canonicalTag = document.querySelector('link[rel="canonical"]');
            if (!canonicalTag) {
                canonicalTag = document.createElement("link");
                canonicalTag.setAttribute("rel", "canonical");
                document.head.appendChild(canonicalTag);
            }
            const canonicalUrl = window.location.origin + this.$route.fullPath;
            canonicalTag.setAttribute("href", canonicalUrl);
        },
    },
};
